import { useEffect, useRef, useState } from 'react';

// Dispara (uma única vez) quando o elemento observado entra no viewport —
// usado pelos gráficos do Ryan pra só animar quando o usuário rola até eles,
// em vez de assim que os dados chegam da API (que pode acontecer com o
// gráfico ainda fora de tela, fazendo a animação "gastar" antes de ser vista).
export function useInViewOnce<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current || inView) return;
    const observer = new IntersectionObserver(
      entries => { if (entries[0].isIntersecting) { setInView(true); observer.disconnect(); } },
      { threshold: 0.2 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [inView]);

  return { ref, inView };
}
